module.exports = __webpack_public_path__ + "static/media/223-300.b6a9155b.webp";